import type { GroupLeaderboardEntry } from '../../../src/friends/helpers/groupLeaderboard.helper'
import type { ChallengeWithStats } from '../../../types/challenges'

/** Unified list item for FlashList (leaderboard + history + footer). */
export type GroupUnifiedListItem =
  | { type: 'table_header' }
  | { type: 'leaderboard_row'; entry: GroupLeaderboardEntry }
  | { type: 'empty_leaderboard' }
  | { type: 'history_title' }
  | { type: 'challenge_card'; challenge: ChallengeWithStats; selectedId: string | null }
  | { type: 'empty_history' }
  | { type: 'leave_footer' }

export function getUnifiedItemType(item: GroupUnifiedListItem): string {
  return item.type
}
